import React from 'react';
const SvgTextfileThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M11 3v94h78V23H69V3H11z" />
      <path fill="#769CC2" d="M69 3l20 20H69V3z" />
      <path opacity={0.3} fill="#1B3F63" d="M69 23h20v20L69 23z" />
      <g fill="#FFF">
        <path d="M26 30h48v3H26zM26 39h48v3H26zM26 48h48v3H26zM26 57h48v3H26zM26 66h40v3H26z" />
      </g>
    </svg>
  );
});
export default SvgTextfileThumbnail;
SvgTextfileThumbnail.iconName = 'textfile-thumbnail';
SvgTextfileThumbnail.displayName = 'SvgTextfileThumbnail';
